import { ConfigurationModuleParams } from '@dazn/bootstrap-main';

import configBeta from '../config.beta.json';
import configLive from '../config.live.json';

import { Win } from './Win';

/* eslint-env node */
const BETA_DOMAINS = [
    'beta.dazn.com',
    'beta-stag.dazn.com',
    'beta-test.dazn.com',
    'beta-dev.dazn.com',
    'beta.kayosports.com.au',
    'beta.binge.com.au',
    'watch-beta.foxtel.com.au',
    'beta.foxsports.com.au',
];

export const getConfigByHostname = (window: Win) =>
    (BETA_DOMAINS.includes(window.location.hostname)
        ? configBeta
        : configLive) as unknown as ConfigurationModuleParams;
